import { render } from "./Quotations.vue?vue&type=template&id=313defcb&scoped=true"
import script from "./Quotations.vue?vue&type=script&lang=js"
export * from "./Quotations.vue?vue&type=script&lang=js"

import "./Quotations.vue?vue&type=style&index=0&id=313defcb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-313defcb"]])

export default __exports__